/* global __HOT__ */
declare var __HOT__: string

import domready from 'domready'
import { toArray, createUniqueId } from '@nrk/dh-utils'
import { createErrorReporter } from '../lib/errorReporting'
import { App } from './components/App'
import { createGoogleAnalyticsTracker } from '@nrk/dh-analytics-utils'
import { preloadReady } from 'react-loadable'
import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'preact-redux'
import { Provider as ContextProvider } from '../lib/provider'
import { reducer } from './reducers'
import { gaMiddleware } from './middleware/gaMiddleware'

const { h, render } = require('preact')

const { root: rootElementClassName } = require('./components/App.css')
window[rootElementClassName] = window[rootElementClassName] || {}

function init() {
  findElements(rootElementClassName).forEach(el => {
    el.id = createUniqueId()
    window[rootElementClassName][el.id] = true

    // Extract values sent from server
    const name = el.getAttribute('data-name')

    // Parse initial state
    const preloadedState = JSON.parse(
      decodeURIComponent(el.getAttribute('data-preloaded-state'))
    )

    // Mutate initial state
    preloadedState.general.isServer = false
    preloadedState.general.urls.currentUrl += window.location.search
    preloadedState.general.urls.INITIAL_URL += window.location.search

    // Parse error tracking flag
    const errorTrackingEnabled =
      el.getAttribute('data-error-tracking-enabled') === 'true'

    // setup error reporting
    const simpleErrorReport = createErrorReporter(name, errorTrackingEnabled)
    // @ts-ignore
    simpleErrorReport.listenAndCatch()

    // Extract metadata required to create google analytics tracker
    const gaPropertyId = el.getAttribute('data-ga-property-id')

    const metadata = JSON.parse(
      decodeURIComponent(el.getAttribute('data-metadata'))
    )
    const { title, selfId, published } = metadata

    // create google analytics tracker
    const googleAnalyticsTracker = (() => {
      try {
        return createGoogleAnalyticsTracker({
          name: 'dh',
          gaPropertyId,
          self: {
            id: selfId,
            title,
            publishedDate: published ? new Date(published) : null
          },
          context: {
            id: '2.7455'
          }
        })
      } catch (err) {
        console.log('Error in creation of GA tracker', err)
        return {}
      }
    })()

    const sendError = message => {
      try {
        // @ts-ignore
        simpleErrorReport.sendErrorReport({ message })
      } catch (err) {
        console.error('Error in sendError', err)
      }
    }

    const sendGaEvent = eventObj => {
      // @ts-ignore
      googleAnalyticsTracker.sendEvent({
        category: `dh-fotballvm-2018`,
        ...eventObj
      })
    }

    // ... and render with the exact same props as on server
    const middlewares = applyMiddleware(thunk, gaMiddleware(sendGaEvent))

    const store = createStore(reducer, preloadedState, compose(middlewares))

    preloadReady().then(() => {
      sendGaEvent({ action: 'load', label: 'center' })
      render(
        <ContextProvider sendGaEvent={sendGaEvent}>
          <Provider store={store}>
            <App />
          </Provider>
        </ContextProvider>,
        el,
        el.firstChild
      )
    })

    // Enable webpack hot-reloading
    // if (__HOT__) {
    //   // Reload and re-render preact application
    //   // @ts-ignore
    //   module.hot.accept('./client', () => {
    //     const { App } = require('./components/App')
    //     render(
    //       <Provider store={store}>
    //         <App {...preloadedState} />
    //       </Provider>,
    //       el,
    //       el.firstChild
    //     )
    //   })
    // }
  })
}

/* if (__HOT__) {
  // tslint:disable:no-submodule-imports
  require('preact/debug')
} */

function findElements(className) {
  return toArray(document.getElementsByClassName(className)).filter(
    el => !isInitialized(el, className)
  )
}

function isInitialized(el, className) {
  return el.id && window[className][el.id]
}

domready(init)
